<template>
  <club-layout>
    <template>
      <player-info-blue-panel
        :invoice="invoice"
        :balance="balance"
        :insurance="insurance"
        :description="description"
      />

      <div id="container">
        <div id="operations">
          <label for="amount">Сумма: <sup class="required_field">*</sup></label>
          <input type="number" id="amount" name="amount" v-model="amount">
          <span>При отрицательном значении, сумма будет снята со счета и зачислена на баланс</span>
        </div>

        <div id="buttons">
          <blue-button :title="'Перечислить'" :onClick="onTransferClick" style="margin-right: 5px" />
          <blue-button :title="'Отмена'" :onClick="onCancelClick" />
          <red-button :title="'Снять всю сумму со счета'" style="float: right;" :onClick="onWithdrawAllClick" />
        </div>
      </div>
    </template>
  </club-layout>
</template>

<script>
  import utils from '../../utils';
  import PlayerInfoBluePanel from './panels/PanelBlue/PanelBluePlayerInfo';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: "ClubPlayerTransferPage",
    components: {
      PlayerInfoBluePanel,
    },
    data() {
      return {
        invoice: null,
        amount: null,
        balance: 0,
        insurance: null,
        description: null,
      }
    },
    computed: {
      ...mapGetters(['currency']),
    },
    methods: {
      ...mapActions(['getInvoice', 'depositToInvoice', 'withdrawFromInvoice', 'withdrawAllFromInvoice']),
      onCancelClick() {
        this.$router.replace('/club/invoice/list');
      },
      async onTransferClick() {
        const amount = utils.convertCurrencyToSystem(this.amount, this.currency);
        const playerId = parseInt(this.$route.params.id, 10);
        if (amount > 0) {
          await this.depositToInvoice({ playerId, amount });
        } else {
          await this.withdrawFromInvoice({ playerId, amount: Math.abs(amount) });
        }
        this.$router.replace('/club/invoice/list');
      },
      async onWithdrawAllClick() {
        await this.withdrawAllFromInvoice({ playerId: parseInt(this.$route.params.id, 10) });
        this.$router.replace('/club/invoice/list');
      },
    },
    async created() {
      const invoice = await this.getInvoice({ playerId: this.$route.params.id });
      this.invoice = invoice.invoice;
      this.balance = invoice.balance;
      this.insurance = invoice.insurance;
      this.description = invoice.description;
    }
  }
</script>

<style scoped>
  #container {
    margin-top: 20px;
  }
  h2 {
    text-align: center;
    font-size: 18px;
    color: #666;
    font-family: Verdana,sans-serif;
    font-weight: normal;
  }
  #operations {
    width: 60%;
    margin-bottom: 25px;
    position: relative;
  }
  #operations label {
    font-size: 13px;
    line-height: 13px;
    display: block;
    color: #424242;
    margin-bottom: 7px;
    font-weight: bold;
    font-family: 'arial', sans-serif;
  }
  #operations label sup {
    color: #ff7058;
  }
  #operations input[type="number"] {
    font-size: 14px;
    display: block;
    margin: 0;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    padding: 0;
    color: #3b3b3b;
    line-height: 27px;
    height: 27px;
    text-indent: 5px;
  }
  #operations span {
    font-size: 11px;
    line-height: 13px;
    color: #999999;
    margin-top: 5px;
    font-family: Verdana, sans-serif;
  }
  #buttons {
    background: #e0edf8;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 15px;
  }
</style>
